/**
 * Toolbar filter pill — small rounded button with active/inactive states.
 * Shared between the FilterPopover and the left-panel firm chips.
 */
export function FilterPill({ active, onClick, color = 'emerald', children, testId }) {
  const palette = {
    emerald: active ? 'bg-emerald-500 text-white border-emerald-500' : 'border-slate-200 text-slate-600 hover:bg-slate-50',
    indigo:  active ? 'bg-indigo-500 text-white border-indigo-500'   : 'border-slate-200 text-slate-600 hover:bg-slate-50',
    blue:    active ? 'bg-blue-500 text-white border-blue-500'       : 'border-slate-200 text-slate-600 hover:bg-slate-50',
    sky:     active ? 'bg-sky-500 text-white border-sky-500'         : 'border-slate-200 text-slate-600 hover:bg-slate-50',
    teal:    active ? 'bg-teal-500 text-white border-teal-500'       : 'border-slate-200 text-slate-600 hover:bg-slate-50',
    amber:   active ? 'bg-amber-500 text-white border-amber-500'     : 'border-slate-200 text-slate-600 hover:bg-slate-50',
  }[color];
  return (
    <button onClick={onClick} className={`px-2.5 py-1 text-xs rounded-full border transition-colors ${palette}`} data-testid={testId}>
      {children}
    </button>
  );
}
